import __var_0__ from '@stdlib/stats/base/dvarmpn';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var dvarmpn = __var_0__;


// MAIN //

/**
* Computes the variance of a double-precision floating-point strided array provided a known mean.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {number} mean - mean
* @param {number} correction - degrees of freedom adjustment
* @param {Float64Array} x - input array
* @param {integer} stride - stride length
* @returns {number} variance
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
*
* var x = new Float64Array( [ 1.0, -2.0, 2.0 ] );
*
* var v = dvarm( x.length, 1.0/3.0, 1, x, 1 );
* // returns ~4.3333
*/
function dvarm( N, mean, correction, x, stride ) {
	return dvarmpn( N, mean, correction, x, stride );
}


// EXPORTS //
export default dvarm;
